import axios, { API_URL } from '@propertypal/shared/src/services/axios';
import { Property } from '@propertypal/shared/src/types';
import PageNotFound from '@propertypal/web-ui/src/jumbotrons/PageNotFound';
import Head from 'next/head';
import { GetServerSideProps, GetServerSidePropsContext } from 'next/types';
import React, { FunctionComponent } from 'react';
import generateMetaTags from '../components/layout/MetaTags';
import PropertyPrintDetails from '../components/property-print/PropertyPrintDetails';
import { requireAuthToken } from '../utils/auth';

const getData = async (ctx: GetServerSidePropsContext): Promise<Property> => {
  try {
    const result = await axios<Property>(
      {
        method: 'GET',
        url: `${API_URL}/property/${ctx.query.property}`,
      },
      undefined,
      ctx,
    );
    return result.data;
  } catch (err: any) {
    if (err.response && err.response.status) {
      ctx.res.statusCode = err.response.status;
      if (err.response.status === 404) return err.data;
    }

    throw err;
  }
};

export const getServerSideProps: GetServerSideProps = requireAuthToken(async (ctx) => {
  const property = await getData(ctx);

  ctx.res.statusCode = property && property.published ? 200 : 404;

  return {
    props: {
      property,
      disableHeader: !!property.published,
      disableFooter: !!property.published,
    },
  };
});

interface Props {
  property: Property;
}

const PropertyPrintPage: FunctionComponent<Props> = (props) => {
  const { property } = props;

  if (!property || (property && !property.published)) return <PageNotFound />;

  return (
    <>
      <Head>
        {generateMetaTags({
          title: property.metaDescriptions.title,
          description: property.metaDescriptions.description,
          url: `/property-print?property=${property.id}`,
        })}
      </Head>

      <PropertyPrintDetails property={property} />
    </>
  );
};

export default PropertyPrintPage;
